import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios';
import Fade from './Fade.js';
import {Loader} from './Loader.js';


export class EmailConfirmation extends Component {

    state = {
       success: null,
      isSending:true
      //success: true,
        //isSending:!true
    }
   
    
    constructor(props) {
        super(props)
        this.props = props 
        
        //alert(this.props.match.params.token)
        this.token = this.props.match.params.token
    }

    componentDidMount() {
        
        
        axios
        .post( process.env.REACT_APP_BACKEND_SERVER+'/CreateUserAndConfirmEmail/', {
            token:this.token
        })
        .then(res => {
           
            
            if (res.data.status == 'ok') {
                
                 
                this.setState( {
                    success : true,
                    isSending : false 
                
                });

            }
            
            
        })
        .catch(err => {
            console.log(err);
            alert('error')
            this.setState( {
                
                isSending : false 
            
            });
        })
          
          

    }
    
    render() {
        
        return (
            <RegWrapper showErrorMsg={false} >
                <Loader loader={this.state.isSending} />
            <>{
                this.state.success === null ? null : null
            } </>  
            <>{
                this.state.success === true ? 
                <div>
                    <div>
                        <h1>Спасибо, ваш Email подтвержден!</h1>
                    </div>
            
                    <div>
                        <a href='/auth' className="btn1">Вход</a>
                    </div>
                </div>
                 : null
            } </> 
            <>{
                this.state.success === false ? 
                <div>
                   <h1> error </h1>
                </div>
                 : null
            } </> 
            </RegWrapper>

        )        
    }

}